import ERC1271 from './ERC1271.json'
import ERC20 from './ERC20.json'
import ERC721 from './ERC721.json'
import UniswapV2Factory from './UniswapV2Factory.json'
import UniswapV2Pair from './UniswapV2Pair.json'
import UniswapV2Router02 from './UniswapV2Router02.json'
import UniswapV3Factory from './UniswapV3Factory.json'
import UniswapV3Pool from './UniswapV3Pool.json'
import UniswapV3SwapRouter from './UniswapV3SwapRouter.json'
import WETH from './WETH.json'

const abis = {
  ERC1271,
  ERC20,
  ERC721,
  UniswapV2Factory,
  UniswapV2Pair,
  UniswapV2Router02,
  UniswapV3Factory,
  UniswapV3Pool,
  UniswapV3SwapRouter,
  WETH,
}

export default abis
